/**
 * Serializes OneSignal SDK work across the logout thunk, route changes, and push hook boot.
 * Without this, `logout()` + immediate `history.push` can unmount before `OneSignal.logout()`
 * finishes; the next user's `init` / `login` then races the old session and OneSignal's
 * `/users` + `/identity` calls may never run until a full page refresh.
 */
let chain: Promise<unknown> = Promise.resolve();

export function enqueueOneSignalOperation<T>(fn: () => Promise<T>): Promise<T> {
  const next = chain.then(fn, fn);
  chain = next.then(
    () => undefined,
    () => undefined
  );
  return next;
}
